export const MAX_EXPENSE_LINES = 100;

export const SYSTEM_EXPENSE_CATEGORIES = [
  'rent',
  'utilities',
  'fuel',
  'transport',
  'salaries',
  'airtime',
  'food',
  'marketing',
  'repairs',
  'maintenance',
  'cleaning',
  'security',
  'taxes',
  'bank_fees',
  'miscellaneous',
] as const;

export const isSystemExpenseCategory = (value: string): boolean =>
	(SYSTEM_EXPENSE_CATEGORIES as readonly string[]).includes(value.trim().toLowerCase());

/** Translate built-in tags only. Custom names stay exactly as entered. */
export const expenseCategoryLabel = (
	value: string,
	translate: (key: string) => string,
): string => {
	const raw = String(value ?? "").trim();
	if (!raw) return "";
	const key = raw.toLowerCase();
	if (!isSystemExpenseCategory(key)) return raw;
	const translated = translate(`common:expense.categories.${key}`);
	if (
		!translated ||
		translated === `common:expense.categories.${key}` ||
		translated.startsWith("common:")
	) {
		return raw;
	}
	return translated;
};

export type ExpenseRow = {
  id: number;
  date: string;
  amount: number;
  mode: number;
  mode_name: string;
  depot?: number | null;
  depot_name?: string | null;
  category: string;
  payee: string;
  batch?: string;
  number?: string;
  description?: string | null;
  user?: string;
  created?: string;
  updated?: string;
};

export type ExpenseCategoryOption = {
  category: string;
  count: number;
  system: boolean;
};

export type ExpensePayeeOption = {
  name: string;
  sources: string[];
  count: number;
};

export type ExpenseDepotOption = {
  id: number;
  depot_name?: string;
  name?: string;
};

export const formatExpenseNumber = (id?: number | string | null) => {
  const value = Number(id);
  if (!Number.isFinite(value) || value <= 0) return '—';
  const padded = value < 1000 ? String(Math.trunc(value)).padStart(4, '0') : String(Math.trunc(value));
  return padded;
};

export const expenseNumber = (row?: { id?: number | string | null; number?: string | null } | null) =>
  String(row?.number || '').trim() || formatExpenseNumber(row?.id);
